import { customElement, property } from 'lit/decorators.js';
import { LitElement } from "lit";
import './table.scss';

/**
 * An example element.
 *
 * @slot - This element has a slot
 */
@customElement('sbk-table')
export class SbkTable extends LitElement {

    @property()
    variant: 'default' | 'card' = 'default';

    createRenderRoot() {
        return this;
    }

    connectedCallback() {
        // @ts-expect-error: guard-super-call
        if (super.connectedCallback) {
            super.connectedCallback();
        }
        if (this.variant === 'card') {
            // eslint-disable-next-line
            const tableHeadCells = this.querySelectorAll('th');
            // eslint-disable-next-line
            const tableBodyRows = this.querySelectorAll('tbody tr');
            tableHeadCells && tableBodyRows && tableBodyRows.forEach(tableRow => {
                const tableCells = tableRow.querySelectorAll('td')
                tableCells && tableCells.forEach((tableCell, index) => {
                    tableCell.innerHTML = '<div class=table__card-content>'+tableCell.innerHTML+'</div>';
                    tableCell.insertAdjacentHTML('afterbegin', '<span class="table__card-header" aria-hidden="true">' + tableHeadCells[index].innerText + '</span>');
                });
            });
        }
    }

}
